import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type CompanyIconProps = CommonSvgProps

const CompanyIcon: React.FC<CompanyIconProps> = React.forwardRef<SVGSVGElement, CompanyIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 33 33" {...props} ref={ref} color="none">
      <path d="M22.823 10.748H11.007v2.844h11.816v-2.844Z" fill="#7BB835" />
      <path
        d="M19.002 24.643h-4.046a.675.675 0 0 0-.675.674v2.968c0 .223.182.404.405.404h4.586a.405.405 0 0 0 .404-.404v-2.967a.675.675 0 0 0-.674-.675Zm0 3.372h-4.046v-2.698h4.046v2.698Z"
        fill="#51565C"
        stroke="#51565C"
        strokeWidth={0.035}
      />
      <path d="M22.823 15.527H11.007v2.844h11.816v-2.844Z" fill="#53A2D9" />
      <path
        d="M28.444 28.015h-3.035V10.143c0-.93-.756-1.686-1.686-1.686H21.7V7.11a.675.675 0 0 0-.674-.675h-1.012V3.062c0-.445-.674-.446-.674 0v3.372h-2.024V3.062c0-.445-.674-.446-.674 0v3.372h-3.709a.675.675 0 0 0-.674.675v1.348h-2.024c-.93 0-1.686.757-1.686 1.686v17.872H5.515a.675.675 0 0 0-.675.674v1.674c0 .372.303.675.675.675h22.93a.675.675 0 0 0 .674-.675V28.69a.675.675 0 0 0-.675-.674ZM12.933 7.109h8.093v1.348h-8.093V7.11Zm15.511 23.255H5.514v-1.675h3.372a.337.337 0 0 0 .338-.337V10.143c0-.557.453-1.011 1.011-1.011h13.488c.558 0 1.012.454 1.012 1.011v18.21c0 .185.15.336.337.336h3.372v1.675Z"
        fill="#51565C"
        stroke="#51565C"
        strokeWidth={0.5}
      />
      <path
        d="M22.712 10.481H11.247a.675.675 0 0 0-.674.674v2.024c0 .371.302.674.674.674h11.465a.675.675 0 0 0 .674-.674v-2.024a.675.675 0 0 0-.674-.674Zm0 2.698H11.247v-2.024h11.465v2.024ZM22.712 19.917H11.247a.675.675 0 0 0-.674.674v2.024c0 .372.302.674.674.674h11.465a.675.675 0 0 0 .674-.674v-2.023a.675.675 0 0 0-.674-.675Zm0 2.698H11.247v-2.023h11.465v2.023ZM22.712 15.201H11.247a.675.675 0 0 0-.674.675v2.023c0 .372.302.674.674.674h11.465a.675.675 0 0 0 .674-.674v-2.023a.675.675 0 0 0-.674-.675Zm0 2.698H11.247v-2.023h11.465v2.023Z"
        fill="#51565C"
        stroke="#51565C"
        strokeWidth={0.035}
      />
    </Svg>
  )
)

CompanyIcon.propTypes = commonPropTypes
CompanyIcon.defaultProps = commonDefaultProps

export default CompanyIcon
